import React from "react";
import { Icon } from "@iconify/react";

import { Button } from "../../ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";

const DataTablePagination = ({ table, totalDocs }) => {
  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 p-3 sm:p-4 bg-[#1a1a1a] rounded-md border border-[#3a3a3c]">
      <div className="text-xs text-gray-400 text-center sm:text-left w-full sm:w-auto">
        {totalDocs > 0 ? (
          <>
            Showing items{" "}
            {table.getState().pagination.pageIndex *
              table.getState().pagination.pageSize +
              1}
            -
            {Math.min(
              (table.getState().pagination.pageIndex + 1) *
                table.getState().pagination.pageSize,
              totalDocs
            )}{" "}
            of {totalDocs}
          </>
        ) : (
          "No items to display"
        )}
      </div>
      <div className="flex flex-col sm:flex-row items-center gap-2 w-full sm:w-auto">
        <div className="flex items-center gap-2 w-full sm:w-auto">
          <button
            onClick={() => table.previousPage()}
            disabled={!table.getCanPreviousPage()}
            className={`px-3 py-1.5 rounded text-xs flex items-center justify-center flex-1 sm:flex-none ${
              !table.getCanPreviousPage()
                ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                : "bg-metaxseed-blue text-white hover:bg-metaxseed-open-blue"
            }`}
          >
            <Icon icon="bi:arrow-left" className="mr-1" width="12" />
            Previous
          </button>
          <div className="px-3 py-1.5 bg-[#1a1a1a] rounded border border-[#3a3a3c] text-xs text-gray-400 text-center min-w-[100px]">
            Page {table.getState().pagination.pageIndex + 1} of{" "}
            {table.getPageCount()}
          </div>
          <button
            onClick={() => table.nextPage()}
            disabled={!table.getCanNextPage()}
            className={`px-3 py-1.5 rounded text-xs flex items-center justify-center flex-1 sm:flex-none ${
              !table.getCanNextPage()
                ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                : "bg-metaxseed-blue text-white hover:bg-metaxseed-open-blue"
            }`}
          >
            Next
            <Icon icon="bi:arrow-right" className="ml-1" width="12" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default DataTablePagination;
